export const EPSG_4326 = "EPSG:4326"; // WGS84 utilisé par l'étendue fournie par le serveur
export const EPSG_3857 = "EPSG:3857"; // Web Mercator pour l'affichage
export const ANOMALIE_CATEGORIE_SYSTEME = "SYSTEME";

export const THEMATIQUE_POINT_EAU = "POINT_EAU";
export const THEMATIQUE_RCI = "RCI";

export const CODE_COUCHE_RCCI = "RCCI"; //Code la couche RCCI et de son groupe pour gérer son affichage dans le front

export const RESOLUTION_ZOOM = 0.29858214173896974; // Correspond au niveau de zoom, utilisé pour le zoom sur les toponymies

export const PAGINATION_OPTIONS = [10, 15, 25, 50, 100];

export const DEFAULT_PAGINATION = 15; // Nombre d'éléments par page pour les tableaux

export const AUCUNE_TOURNEE = "AUCUNE_TOURNEE"; // Valeur de filtre pour les PEIs sans tournée associée

export const MIN_ZOOM_COUCHE_TRANSPARENTE = 12;
